import { Injectable } from '@angular/core'
import { Firestore, query } from '@angular/fire/firestore'
import { collection } from '@angular/fire/firestore'
import { doc, DocumentReference, getDoc, getDocs, limit, orderBy, where } from 'firebase/firestore'
import { FirestoreStructure, LogWhatsapp } from '@parkupp/core'

/**
 * Frontend service for reading WhatsApp send audit logs from FirestoreStructure.LOG_WHATSAPPS.
 *
 * Mirrors LogEmailService. All writes happen on the backend via the Admin SDK; the UI is read-only.
 */
@Injectable({
    providedIn: 'root',
})
export class LogWhatsappService {
    collection = collection(this.firestore, FirestoreStructure.LOG_WHATSAPPS)

    constructor(public firestore: Firestore) {}

    getDocRef(key: string) {
        return doc(this.collection, key)
    }

    async getLogWhatsapp(logWhatsappDocRef: DocumentReference) {
        const snap = await getDoc(logWhatsappDocRef)
        const log = new LogWhatsapp(snap.data() as Partial<LogWhatsapp>)
        log.$key = snap.id
        return log
    }

    async listByMerchant(merchantDocRef: DocumentReference, max: number = 100): Promise<LogWhatsapp[]> {
        const q = query(this.collection, where('merchantRef', '==', merchantDocRef), orderBy('createdAt', 'desc'), limit(max))
        const snapshot = await getDocs(q)
        return snapshot.docs.map((d) => {
            const log = new LogWhatsapp(d.data() as Partial<LogWhatsapp>)
            log.$key = d.id
            return log
        })
    }

    async listBySubscription(subscriptionDocRef: DocumentReference, max: number = 100): Promise<LogWhatsapp[]> {
        const q = query(this.collection, where('subscriptionRef', '==', subscriptionDocRef), orderBy('createdAt', 'desc'), limit(max))
        const snapshot = await getDocs(q)
        return snapshot.docs.map((d) => {
            const log = new LogWhatsapp(d.data() as Partial<LogWhatsapp>)
            log.$key = d.id
            return log
        })
    }

    async listByClient(clientDocRef: DocumentReference, max: number = 100): Promise<LogWhatsapp[]> {
        const q = query(this.collection, where('clientRef', '==', clientDocRef), orderBy('createdAt', 'desc'), limit(max))
        const snapshot = await getDocs(q)
        return snapshot.docs.map((d) => {
            const log = new LogWhatsapp(d.data() as Partial<LogWhatsapp>)
            log.$key = d.id
            return log
        })
    }
}
